import React from 'react';
import { EnvironmentalControlBoardJudgment as EnvironmentalControlBoardJudgmentModel } from 'pages/Search/models';
import { Descriptions, Tooltip, Checkbox } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Date, formatPriceString, tabSelector, getDataTypeName } from 'common';
import { searchIsSelectedUpdate, isSelectedSelector } from 'pages/Search';
import { createSelector } from 'reselect';
import { ResultTypeName } from 'pages/Search/Search.types';

const selector = createSelector(
  tabSelector,
  isSelectedSelector,
  (tabName, getIsSelected) => ({
    tabName,
    getIsSelected,
  }),
);
const EnvironmentalControlBoardJudgment: React.FC<{
  judgment: EnvironmentalControlBoardJudgmentModel;
  index: number;
  resultType: ResultTypeName;
  resultItemIndex: number;
}> = ({ judgment, index, resultType, resultItemIndex }) => {
  const dispatch = useDispatch();
  const { tabName, getIsSelected } = useSelector(selector);

  const {
    firstName,
    lastName,
    address,
    orderDate,
    noticeDate,
    docketDate,
    balance,
    violationNumber,
    guid,
    documentType,
  } = judgment;

  const onChange = ({ target: { checked } }: any) => {
    dispatch(
      searchIsSelectedUpdate(
        getDataTypeName(tabName),
        documentType,
        guid,
        checked,
        resultItemIndex,
        resultType,
      ),
    );
  };

  const isSelected = React.useMemo(() => {
    return getIsSelected(
      getDataTypeName(tabName),
      documentType,
      guid,
      resultItemIndex,
      resultType,
    );
  }, [documentType, getIsSelected, guid, resultItemIndex, resultType, tabName]);

  return (
    <>
      <Tooltip title={'Check for export'}>
        #{index + 1}&nbsp;
        <Checkbox onChange={onChange} checked={isSelected} />
      </Tooltip>
      <Descriptions size="small">
        <Descriptions.Item label="Name">{`${firstName} ${lastName}`}</Descriptions.Item>
        <Descriptions.Item label="Address">{address}</Descriptions.Item>
        <Descriptions.Item label="Order Date">
          <Date>{orderDate}</Date>
        </Descriptions.Item>
        <Descriptions.Item label="Notice Date">
          <Date>{noticeDate}</Date>
        </Descriptions.Item>
        <Descriptions.Item label="Docket Date">
          <Date type="monthYear">{docketDate}</Date>
        </Descriptions.Item>
        <Descriptions.Item label="Balance">
          {formatPriceString(balance)}
        </Descriptions.Item>
        <Descriptions.Item label="Violation Number">
          {violationNumber}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default React.memo(EnvironmentalControlBoardJudgment);
